// Drives a re-render every `intervalMs` so elapsed-time displays tick
// smoothly (otherwise we'd only update on the polling cadence).
//
// Returns a counter that increments — components subscribe by reading
// it but typically don't need its value (just the side-effect render).

import { useEffect, useState } from 'react'

export function useTicker(intervalMs: number = 1000): number {
  const [tick, setTick] = useState(0)
  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return tick
}

/** Format `ms` into "Xms", "X.Xs" or "Xm YYs". Stable, locale-free. */
export function formatElapsed(ms: number): string {
  if (ms < 1000) return `${Math.max(0, ms)}ms`
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`
  const m = Math.floor(ms / 60_000)
  const s = Math.floor((ms % 60_000) / 1000)
  return `${m}m ${s.toString().padStart(2, '0')}s`
}
